import React from 'react';
// import Footer from './Footer';
import {
  useQuery,
} from 'react-query'
import UserProfileDisplay from './UserProfileDisplay';
import { Auth } from "aws-amplify";

export default function VideoDisplay() {
  
  const { isPending, error, data } =useQuery('video_list', async () => {
    const data =await Auth.currentSession();
    const idToken = data.getIdToken().getJwtToken();
    return fetch('https://api.kolandium.com/videolist', {
        headers: {
          Authorization: idToken
        }
      }).then((res) => res.json())
  }
    
  );

  if (isPending) return 'Loading...';

  if (error) return 'An error has occurred: ' + error.message;

  return (
    <div>
      <UserProfileDisplay></UserProfileDisplay>
     {data && data["video_list"].map((item) => (
        <div key={item.title}>{item.title}</div>
      ))}
    </div>
  );
}